<div class="container-price" [class.featured]="plan?.title.toLowerCase() === 'anual'">
  <div
    class="head"
    [class.active-promo]="activePromo"
  >
    <h1>{{ plan?.title || "Sem titulo..." }}</h1>
    <p [innerHTML]="plan?.subtitle || 'Sem subtitulo...'"></p>

    <img
      *ngIf="plan?.title.toLowerCase() === 'anual'"
      class="flag-popular"
      src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/membership/flag-popular.svg"
    >
    <div
      *ngIf="(plan?.internalname === 'semestral' || plan?.internalname === 'anual') && activePromo"
      class="promo-tag">

      <unh-promo-tag value="30%" shape="rectangle"></unh-promo-tag>
    </div>
    <!-- <div class="flag-discount">
      <img src='https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/banner-home-flag.svg'/>
    </div> -->
  </div>

  <div class="body" [class.multiple]="multiple" >
    <div class="all-courses">{{membershipPricingMock?.priceBoxTeamTranslation?.allCoursesText}} </div>
    <!-- //unhide-week -->
    <ng-container *ngIf="activePromo">
      <div class="promo-old-price-wrapper">
        <span *ngIf="plan?.internalname === 'anual' || plan?.internalname === 'semestral'" class="promo-old-price">
          <span class="currency">{{membershipPricingMock?.priceBoxTeamTranslation?.currency}}</span>
          <span class="price">{{ plan?.invidualTotalPrice / plan?.cycle_months | number:'1.0-0'  }}</span>
          <span class="month">{{membershipPricingMock?.priceBoxTeamTranslation?.month}}</span>
          <mat-icon svgIcon="promo-old-price-line">

          </mat-icon>
        </span>
      </div>
    </ng-container>

    <!-- // Multiple -->
    <ng-container *ngIf="multiple">
      <h1 class="orinalprice">
        <div>{{membershipPricingMock?.priceBoxTeamTranslation?.currency}}</div>
        <span>{{ plan?.price}}</span>
        <div>{{membershipPricingMock?.priceBoxTeamTranslation?.month}}</div>
      </h1>

      <h1 class="finalprice">
        <div>{{membershipPricingMock?.priceBoxTeamTranslation?.currency}}</div>
        <span>{{ multipleTotalPrice }}</span>
        <div>{{membershipPricingMock?.priceBoxTeamTranslation?.month}}</div>
      </h1>

      <div class="input-container">
        <label>
          <input
            #qtyartists
            [(ngModel)]="qtyTeamArtists"
            (input)="onChangeQtyArtist(qtyartists, plan?.price)"
            (blur)="resetInputQtyartists(qtyartists)"
          />

          {{membershipPricingMock?.priceBoxTeamTranslation?.inputLabel}}
        </label>
      </div>
    </ng-container>

    <!-- // Normal -->
    <ng-container *ngIf="!multiple">
      <h1 *ngIf="plan?.free">{{membershipPricingMock?.priceBoxTeamTranslation?.h1Free}}</h1>

      <h1 *ngIf="!plan?.free" class="finalprice">
        <div>{{membershipPricingMock?.priceBoxTeamTranslation?.currency}}</div>

        <div>
          <span>{{ plan?.price / plan.cycle_months  | number:'1.0-0' }}</span>
        </div>

        <div>{{membershipPricingMock?.priceBoxTeamTranslation?.month}}<div *ngIf="plan?.cycle_months > 1">*</div></div>
      </h1>

      <div class="description">
        <p class="typo-12" *ngIf="plan.cycle_months === 1">{{membershipPricingMock?.priceBoxTeamTranslation?.descriptionRenewText}}<br><strong>{{membershipPricingMock?.priceBoxTeamTranslation?.descriptionRenewStrongText}}</strong></p>
        <p class="typo-12" *ngIf="plan.cycle_months > 1"><strong>{{membershipPricingMock?.priceBoxTeamTranslation?.currency}} {{ plan?.price  | number:'1.0-0'  }}</strong>
          <ng-container *ngIf="plan.installments">
            {{membershipPricingMock?.priceBoxTeamTranslation?.textBeforeInstallments}} {{plan.installments}}{{membershipPricingMock?.priceBoxTeamTranslation?.textAfterInstallments}}<br>
            <strong>{{membershipPricingMock.priceBoxTeamTranslation.strongSaveText}} {{ plan.savedMoney }}</strong>
          </ng-container>
        </p>
      </div>

      <div class="payment-methods">
        <span class="payment-method">
          <mat-icon svgIcon="unh_creditcard_pink"></mat-icon> {{membershipPricingMock?.priceBoxTeamTranslation?.paymentMethodCreditCardText}}
        </span>

        <span class="payment-method" *ngIf="plan.cycle_months !== 1">
          <mat-icon svgIcon="unh_bankslip_pink"></mat-icon> {{membershipPricingMock?.priceBoxTeamTranslation?.paymentMethodBankSlipText}}
        </span>
      </div>
    </ng-container>

    <ng-container *ngIf="showRenewButton && plan.title.toLowerCase() != 'team'">
      <button
        mat-button
        class="unh-button-old"
        theme="pink-white"
        [style.opacity]="1"
        [style.visibility]="plan?.title.toLowerCase() === 'mensal' ? 'hidden' : 'visible'"
        [disabled]="plan?.title.toLowerCase() === 'mensal'"
        (click)="onClickToCheckout()"
      >
        <p class="btn-label">{{membershipPricingMock?.priceBoxTeamTranslation?.buttonLabelRenewBundleText}}</p>
      </button>
    </ng-container>

    <ng-container>
      <!-- // Buttons -->
      <button
        *ngIf="!plan?.free && plan?.cycle_months > 0"
        mat-button
        class="unh-button-old"
        theme="pink-white"
        [style.opacity]="1"
        (click)="onClickToCheckout()"
      >
        <!-- <p *ngIf="plan?.cycle_months === 1" class="btn-label">Assinar Plano Mensal</p>
        <p *ngIf="plan?.cycle_months > 1" class="btn-label">Comprar Pacote</p> -->

        <p
          *ngIf="plan?.title.toLowerCase() != 'team'"
          class="btn-label">{{membershipPricingMock?.priceBoxTeamTranslation?.buttonLabelStarNowText}}</p>

        <p
          *ngIf="plan?.title.toLowerCase() == 'team'"
          class="btn-label">
          {{membershipPricingMock?.priceBoxTeamTranslation?.buttonLabelSubscribeText}} <span>TEAM</span
            >&nbsp;<strong>PRO</strong>
        </p>
      </button>

      <button
        *ngIf="!plan?.free && plan?.cycle_months <= 0"
        mat-button
        class="unh-button-old"
        theme="grey-white"
        disabled="disabled"
        [style.opacity]="0.5"
      >
        <p class="btn-label">{{membershipPricingMock?.priceBoxTeamTranslation?.buttonLabelSoonText}}</p>
      </button>

      <button
        *ngIf="plan?.free"
        mat-button
        class="unh-button-old"
        theme="grey-white"
        (click)="onClickToCheckout()"
      >
        <p class="btn-label">{{membershipPricingMock?.priceBoxTeamTranslation?.buttonLabelSubscribeFreeText}}</p>
      </button>
    </ng-container>
  </div>
</div>




